import { useState, useEffect } from "react";

const DEFAULT_PLACEHOLDER = "https://via.placeholder.com/800x1000";

/**
 * Tries each URL in order (e.g. Drive thumbnail, then uc, then googleusercontent).
 */
export function ProductImageWithFallbacks({
  urls = [],
  alt,
  className,
  style,
  loading = "lazy",
  placeholder = DEFAULT_PLACEHOLDER,
  /**
   * Do not default to no-referrer: Drive often allows top-level /view tabs but
   * rejects embedded <img> when Referer is stripped.
   */
  referrerPolicy,
}) {
  const list = (Array.isArray(urls) ? urls : []).filter(Boolean);
  const [index, setIndex] = useState(0);
  const [exhausted, setExhausted] = useState(false);

  const urlKey = list.join("\0");
  useEffect(() => {
    setIndex(0);
    setExhausted(false);
  }, [urlKey]);

  const src =
    exhausted || list.length === 0 || index >= list.length
      ? placeholder
      : list[index];

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      loading={loading}
      {...(referrerPolicy !== undefined ? { referrerPolicy } : {})}
      onError={() => {
        if (index < list.length - 1) {
          setIndex((i) => i + 1);
        } else {
          setExhausted(true);
        }
      }}
    />
  );
}
